

import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {ApiAdminRequestTypeService} from "../../../../../services/api/admin/admin-request-type-api/admin-request-type-api.service";
import {DialogService} from "../../../../../services/dialog-service/dialog.service";
import {AdminRequestTypesComponentDialog} from "./admin-request-types-create-edit-dialog/admin-request-types-create-edit-dialog.component";
import {ModalConfirmationComponent} from "../../../../../shared/modal-confirmation/modal-confirmation.component";
import { SharedService } from 'src/app/shared/service/shared-service';

@Component({
  selector: 'app-admin-request-types',
  templateUrl: './admin-request-types.html'
})
export class AdminRequestTypesComponent implements OnInit {

  data;
  isLoading = true;

  constructor(private apiAdminRequestTypeService: ApiAdminRequestTypeService, private dialogService: DialogService, private viewReference: ViewContainerRef,  private sharedService: SharedService) {
    this.getData();
  }

  ngOnInit(): void {
  }

  getData(){
    this.isLoading = true;
    this.apiAdminRequestTypeService.listAll().then(response => {
      this.data = response;
      this.isLoading = false;
    }).catch(error => {
      this.isLoading = false;
      if (error.status === 403) {
        window.location.href = '/';  // Redirect to self-service
      } else {
        console.log('Unhandled error:', error);
      }
    });
  }

  create(){
    // Replace null with Component
    this.dialogService.createDialog(AdminRequestTypesComponentDialog, null, this.viewReference)
      .then(dialogSaved => {
        this.getData();
        this.sharedService.reloadAgentFilters();
        this.sharedService.reloadRequestTypes();
      }, dialogCancelled => {

      })
  }

  delete(id){
    this.dialogService.createDialog(ModalConfirmationComponent, 'Are you sure?', this.viewReference)
      .then(confirmed => {
        this.apiAdminRequestTypeService.delete(id).then(response => {
          this.getData();
          this.sharedService.reloadRequestTypes();
          this.sharedService.reloadAgentFilters();
      })
       
        
      }, cancelled => null)
  }



}
